<template>
  <section
    class="new-collection"
    v-if="getCurrentRelatedProducts.length"
  >
    <header class="container">
      <h2>
        {{ heading }}
      </h2>
    </header>
    <product-listing columns="4" :products="getCurrentRelatedProducts" />
  </section>
</template>

<script>
import Related from './Related.vue'
import { prepareRelatedQuery } from '@vue-storefront/core/modules/catalog/queries/related'

export default {
  mixins: [Related],
  methods: {
    async refreshList () {
      if (!this.getCurrentProduct[this.type]) {
        return false
      }

      const relatedProductsQuery = prepareRelatedQuery('category_ids', this.getCurrentProduct[this.type])

      const { items } = await this.$store.dispatch('product/findProducts', {
        query: relatedProductsQuery,
        size: 1000,
        sort: JSON.stringify([
          {
            'category.position': {
              mode: 'avg',
              order: 'asc',
              nested_path: 'category',
              nested_filter: {
                term: { 'category.category_id': this.getCurrentProduct[this.type] }
              }
            }
          }
        ]),
        options: {
          populateRequestCacheTags: false,
          prefetchGroupProducts: false
        }
      })

      if (items.length) {
        const configuredProducts = items // await this.$store.dispatch('category-next/processCategoryProducts', { products: items })
        this.$store.dispatch('product/related', {
          key: this.type,
          items: configuredProducts
        })
        this.$forceUpdate()
      }
    }
  }
}
</script>
